module.exports = __webpack_public_path__ + "img/medal_svip3.6ed322d.png";